import { writable } from 'svelte/store';

const storedRedirect = localStorage.getItem('auth_redirect');
export const redirect = writable(storedRedirect);

redirect.subscribe((value) => {
  if (value) {
    localStorage.setItem('auth_redirect', value);
  }
});
